import { defineStore } from "pinia";
import { ref } from "vue";
import { client } from "@/main";
import { useProjectStore } from "@/store/modules/project";
export const useLoraStore = defineStore("lora", () => {
    const deviceList = ref([]);
    const devicesOverview = ref(null);
    const totalCount = ref(undefined);
    async function getList(queryData) {
        let sort = undefined;
        if (queryData.sortType == "asc") {
            sort = "+" + queryData.sort;
        }
        else if (queryData.sortType === "desc") {
            sort = "-" + queryData.sort;
        }
        const filters = {};
        for (const filter of queryData.filters ?? []) {
            filters[`${filter.field}[${filter.operator ?? "eq"}]`] = filter.value;
        }
        let search = undefined;
        if (queryData.search) {
            search = `${queryData.search}*`;
        }
        try {
            const { data } = await client.path("/lora/devices").method("get").create()({
                sort,
                ...(filters ?? {}),
                search,
                limit: queryData.rowsPerPage,
                offset: queryData.currentPage * queryData.rowsPerPage
            });
            if (!data) {
                return undefined;
            }
            deviceList.value = data.data ?? [];
            totalCount.value = data.metadata?.count;
            return [...(data.data ?? [])];
        }
        catch (e) {
            console.error(e);
        }
    }
    async function getProjectDevices() {
        const projectStore = useProjectStore();
        const { data } = await client.path("/lora/devices").method("get").create()({
            "projectId[eq]": projectStore.selectedProject?.projectId,
            sort: "-lastMessageIn",
            limit: 8
        });
        deviceList.value = data.data ?? [];
        return true;
    }
    async function deleteDevice(device) {
        if (!device.deviceId) {
            return;
        }
        for (const dg of device.deviceGroups ?? []) {
            if (!dg.deviceGroupId) {
                continue;
            }
            await client.path("/device-groups/{id}/devices/{protocol}/{deviceId}/assign").method("delete").create()({
                protocol: "lora",
                id: dg.deviceGroupId.toString(),
                deviceId: device.deviceId
            });
        }
        return await client.path("/lora/devices/{id}").method("delete").create()({ id: device.deviceId });
    }
    async function getDevicesOverview() {
        const projectStore = useProjectStore();
        if (!projectStore.selectedProject?.projectId) {
            return false;
        }
        const { data } = await client.path("/projects/{id}/devices/overview").method("get").create()({
            id: projectStore.selectedProject?.projectId
        });
        devicesOverview.value = data.data ?? null;
        return true;
    }
    async function moveDevices({ deviceIds, dest_deviceGroup, dest_custServiceId, dest_projectId }) {
        const { data } = await client.path("/lora/devices/migration").method("post").create()(deviceIds.map((deviceId) => ({
            deviceId,
            dest_deviceGroup,
            dest_custServiceId,
            dest_projectId
        })));
        return data;
    }
    async function getDevicesByFilter(filter) {
        const { data } = await client.path("/devices").method("get").create()({
            ...filter
        });
        return data.data;
    }
    return {
        getList,
        deviceList,
        devicesOverview,
        totalCount,
        deleteDevice,
        moveDevices,
        getDevicesByFilter,
        getProjectDevices,
        getDevicesOverview
    };
});
